/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import InsuranceDataContent from "components/content/InsuranceDataContent";

import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";

/**
 * Insurance provider and coverage management page.
 * 
 * Features:
 * - List of insurance providers and payers
 * - Coverage plan details and eligibility rules
 * - Insurance verification and authorization tracking
 * - Claims submission and status monitoring
 * - Payer contract management
 * - Integration with billing encounters
 * 
 * @returns Insurance management page component
 */
const InsurancePage: React.FC = () => {
  return (
    <DefaultDashboardLayout>
      <InsuranceDataContent />
    </DefaultDashboardLayout>
  );
};

export default InsurancePage;

